export function imgUser(a, b) {
  return {
    type: 'IMG_USER',
    payload: {
      img: a,
      type: b,
    },
  };
}
